import {
  isValidPhoneNumber,
  parsePhoneNumberWithError,
} from 'libphonenumber-js';
import { z } from 'zod';

function checkPhoneNumber(value: string) {
  if (!value) return true;

  try {
    const parsedNumber = parsePhoneNumberWithError(value);
    const countryCode = parsedNumber.country;

    return isValidPhoneNumber(value, countryCode);
  } catch {
    return false;
  }
}

const PhoneNumberScheme = z
  .string()
  .refine((val) => checkPhoneNumber(val), 'Phone number is not valid');

export const ParticipantTypeFormSchema = z.object({
  types: z.array(
    z.object({
      id: z.string().nullable().optional(),
      value: z
        .string()
        .min(1, 'Type is required')
        .max(50, 'Type name cannot exceed 50 characters'),
      phoneNumbers: z.array(z.object({ value: PhoneNumberScheme })),
    })
  ),
});
